import React from 'react';
import { connect } from 'react-redux';
import { requestUpdateTask } from 'actions';
import { DatePicker } from 'components';
import { Row, Col, Button } from 'react-bootstrap';
import moment from 'moment';

class TaskReminderDateForm extends React.Component {
  constructor(props) {
    super(props);

    const { reminder_date } = this.props.task;

    this.state = {
      reminder_date: reminder_date || null,
      reminder_time: reminder_date ? moment(reminder_date).utc().format('HH:mm') : '00:00',
      reset_reminder: false
    };

    this.handleSave = this.handleSave.bind(this);
  }

  handleSave() {
    let reminder_date = null;
    if(this.state.reminder_date) {
      const reminder_date_moment = moment(this.state.reminder_date).utc();
      const hour = this.state.reminder_time.substr(0, 2);
      const minute = this.state.reminder_time.substr(3);
      reminder_date_moment.set({ hour, minute });
      reminder_date = reminder_date_moment.toDate();
    }
    const payload = { ...this.props.task, reminder_date };

    this.props.requestUpdateTask(payload);
    this.props.cancel();
  }
  componentWillUpdate() {
    if(this.state.reset_reminder) {
      this.setState({ reset_reminder: false });
    }
  }

  render() {
    return (
      <div className='task-reminder-date-form-container'>
        <div className='task-reminder-date-form-calendar-container task-calendar'>
          <div>
            {this.state.reset_reminder ? (
              <DatePicker
                key='task-form-reset'
                weekNumbers={false}
                dark
              />
            ) : (
              <DatePicker
                key='task-form-reminder-date-calendar'
                weekNumbers={false}
                defaultDate={this.state.reminder_date}
                defaultActiveDate={this.state.reminder_date}
                defaultViewDate={this.state.reminder_date}
                dark
                onChange={d => this.setState({ reminder_date: d })}
              />
            )}
            <div className='task-form-reminder-time-input-container'>
              <Row>
                <Col md={6} xs={6} className='task-reminder-time'>
                  <input
                    type='time'
                    className='form-control'
                    onChange={e => this.setState({ reminder_time: e.target.value })}
                    value={this.state.reminder_time}
                  />
                </Col>
                <Col md={6} xs={6} className='task-reminder-clear'>
                  <Button
                    onClick={() => this.setState({ reminder_date: null, reminder_time: '12:00', reset_reminder: true })}
                    block
                    >
                    Clear
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className='task-reminder-date-form-buttons-container'>
          <Button block bsStyle='success' onClick={this.handleSave}>
            {this.props.tasks.updating_task ? <LoadingSpinner /> : 'Save'}
          </Button>
          <Button block onClick={this.props.cancel}>Cancel</Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ tasks }) => ({ tasks });

export default connect(mapStateToProps, { requestUpdateTask })(TaskReminderDateForm);



// WEBPACK FOOTER //
// ./src/browser/components/tasks/new-tasks/task-reminder-date-form.js